import { jsx as _jsx } from "react/jsx-runtime";
import { GroupInputFacadeWrappedStyled } from './group-input-facade.styles';
/**
 * The `GroupInputFacade` component provides a standardised stylistic way of grouping inputs together with the correct border and spacing.
 */
export const GroupInputFacade = ({ children, }) => _jsx(GroupInputFacadeWrappedStyled, { children: children });
//# sourceMappingURL=group-input-facade.js.map